// 英文语言包
export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    enter: '{field} cannot be empty',
    success: 'Operation successful',
    error: 'Operation failed',
    loading: 'Loading...',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back'
  },
  settings: {
    basic: 'Basic Settings',
    siteName: 'Site Name',
    siteDescription: 'Site Description',
    timezone: 'Timezone',
    language: 'Language',
    notification: 'Notification Settings',
    emailServer: 'Email Server',
    emailPort: 'Email Port',
    emailFrom: 'From Email',
    emailPassword: 'Email Password',
    smtpSecure: 'SMTP Secure Connection',
    testNotification: 'Test Notification',
    monitor: 'Monitor Settings',
    monitorInterval: 'Monitor Interval',
    timeout: 'Timeout',
    alertCooldown: 'Alert Cooldown',
    maxRetries: 'Max Retries',
    security: 'Security Settings',
    loginAttempts: 'Login Attempts',
    lockoutDuration: 'Lockout Duration',
    saveSuccess: 'Save successful',
    testSuccess: 'Test successful'
  },
  dashboard: {
    title: 'Dashboard',
    overview: 'Overview',
    activeAlerts: 'Active Alerts',
    totalTargets: 'Total Targets',
    uptime: 'Uptime',
    responseTime: 'Response Time',
    status: 'Status',
    online: 'Online',
    offline: 'Offline',
    warning: 'Warning'
  },
  'alert-history': {
    title: 'Alert History',
    level: 'Level',
    target: 'Target',
    message: 'Message',
    time: 'Time',
    status: 'Status',
    resolved: 'Resolved',
    pending: 'Pending'
  },
  'alert-rules': {
    title: 'Alert Rules',
    name: 'Rule Name',
    condition: 'Condition',
    threshold: 'Threshold',
    duration: 'Duration',
    actions: 'Actions'
  },
  targets: {
    title: 'Monitoring Targets',
    name: 'Target Name',
    url: 'URL',
    interval: 'Interval',
    timeout: 'Timeout',
    status: 'Status'
  },
  notifications: {
    title: 'Notification Center',
    type: 'Type',
    content: 'Content',
    time: 'Time',
    read: 'Read',
    unread: 'Unread'
  },
  login: {
    title: 'Login',
    username: 'Username',
    password: 'Password',
    remember: 'Remember me',
    submit: 'Login',
    forgot: 'Forgot password?',
    register: 'Register'
  }
}